import { useAuth } from "../../context/AuthContext";
import { PageHeader } from "../../components/PageHeader";
import { SettingsView } from "../../components/SettingsView";
import { BrandCard } from "./BrandCard";

export default function Configuracion() {
  const { me } = useAuth();
  const canEdit = me.usuario.rol === "owner" && !me.soporte;
  return (
    <div className="space-y-8">
      <PageHeader overline="Empresa" title="Configuración" />
      <BrandCard canEdit={canEdit} />
      <SettingsView base="/company" canEdit={canEdit} />
    </div>
  );
}
